/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/require-tagless-components */
import { tagName } from '@ember-decorators/component';
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

@tagName('span')
export default class MenuLabel extends Component {
  text = '';
  @tracked
  isTruncated = false;

  didInsertElement() {
    super.didInsertElement(...arguments);
    this._checkTruncation();
  }

  _checkTruncation() {
    if (this.isDestroyed || this.isDestroying) {
      return;
    }
    this.isTruncated = this.element.scrollWidth > this.element.offsetWidth;
  }
}
